__turbopack_context__.v({
  "bulletList": "O1cb-W_bulletList",
  "diamondList": "O1cb-W_diamondList",
  "list": "O1cb-W_list",
  "listItem": "O1cb-W_listItem",
  "orderedList": "O1cb-W_orderedList",
  "paragraph": "O1cb-W_paragraph",
});
